import React, { useMemo } from "react";
import { bpkbValuationInfo, exclusiveValuationInfo, smartphoneValuationInfo } from "./constants";

const ValuationTab = ({ data }) => {
  const { commonInfo, valuationInfo } = data;
  const category = commonInfo?.productCategory?.toLowerCase();

  const valuationLabelList = useMemo(() => {
    if (category === "car" || category === "bike") {
      return {
        "Harga Taksiran Akhir": valuationInfo?.valuationAmount,
        ...valuationInfo?.valuationData?.reduce((map, obj) => {
          map[obj.label] = obj.value;
          return map;
        }, {}),
      };
    } else if (category === "bpkb") {
      return bpkbValuationInfo;
    } else if (category === "smartphone") {
      return smartphoneValuationInfo;
    } else if (category === "other") {
      return exclusiveValuationInfo;
    }
  }, [category, valuationInfo?.valuationAmount, valuationInfo?.valuationData]);

  return (
    <div className="detail-bold-text">
      {Object.keys(valuationLabelList).map((valuationLabel) => {
        return (
          <div className="row detail-row">
            <div className="col-4">
              {category === "car" || category === "bike"
                ? valuationLabel
                : valuationLabelList[valuationLabel].label}
            </div>
            <div className="col-md-auto">:</div>
            <div className="col">
              {category === "car" || category === "bike"
                ? valuationLabelList[valuationLabel] || "-"
                : valuationInfo?.[valuationLabel] || "-"}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ValuationTab;
